<template>
  <v-card>
    <v-card-title v-if="!ORGANIZATION_IS_FETCHING">{{ title_text }}</v-card-title>
    <v-stepper v-model="stepper_step" v-if="!ORGANIZATION_IS_FETCHING">
      <v-stepper-header>
        <v-stepper-step
          :complete="this.COUNT_ORGANIZATIONS > 0"
          step="1"
        >
          Добавление организации
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          :complete="step_number > 2"
          step="2"
        >
          Добавление номера телефона
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="3"
            :complete="step_number > 3"
        >
          Подключение
        </v-stepper-step>

        <v-divider></v-divider>

        <!-- <v-stepper-step step="4" :complete="step_number > 4">
          Ожидание подключения
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="5"
            :complete="step_number == 5"
        >
          Подключение установлено
        </v-stepper-step> -->
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1">
          <v-row>
            <v-col>
              <h3>Добавьте организацию для подключения сервиса appeals</h3>
            </v-col>
          </v-row>
          <v-row justify="center">
            <orgnization-form class="mb-12" :route_on_success_append="false"></orgnization-form>
          </v-row>
          <v-row justify="center" class="d-flex flex-column align-center">
            <v-row>
              <v-col cols="12">
                <p class="text-h5 text--primary">Видеоинструкция по действиям для подключения сервиса appeals</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <p>
                  <iframe
                    width="560"
                    height="315"
                    src="https://rutube.ru/play/embed/9627c8291824de55c7bbe07f08a59420"
                    frameBorder="0"
                    allow="clipboard-write; autoplay"
                    webkitAllowFullScreen
                    mozallowfullscreen
                    allowFullScreen
                  ></iframe>
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <p class="text-h5 text--primary">Телефон тех. поддержки - 8 800 700-09-54</p>
              </v-col>
            </v-row>
          </v-row>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-card
            :loading="isFetchingMobile"
          >
            <p class="text-h4 text--primary">
              Осталось ввести Ваш контактный номер телефона (лучше мобильный). Сотрудник позвонит и настроит подключение appeals.
            </p>
            <v-card-text>
              <v-row justify="center">
                <v-col lg="4" md="4" sm="6">
                  <v-form
                    ref="formPhone"
                    v-model="validformPhone"
                    lazy-validation
                  >
                    <v-text-field
                      :label="'Телефон'"
                      v-mask="'+7 (###) ### ## ##'"
                      :rules="[v => !!v || 'Телефон обязателен к заполнению', v => v.replace(/\D/g, '').length == 11 || 'Неверный формат телефона']"
                      class="mb-4"
                      outlined
                      dense
                      v-model="new_contact_mobile"
                      placeholder="Номер телефона"
                      persistent-hint>
                    </v-text-field>
                  </v-form>
                </v-col>
                <v-col lg="4" md="4" sm="6">
                  <v-btn
                    color="primary"
                    @click="onOpenConfirmDialog"
                    :disabled="isFetchingMobile"
                  >
                    Продолжить
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="d-flex flex-column">
              <v-row>
                <v-col cols="12">
                  <p class="text-h5 text--primary">Видеоинструкция по действиям для подключения сервиса appeals</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <p>
                    <iframe width="560"
                      height="315"
                      src="https://rutube.ru/play/embed/9627c8291824de55c7bbe07f08a59420"
                      title="Видеоинструкция по действиям для подключения сервиса appeals"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin"
                      allowfullscreen
                    >
                    </iframe>
                  </p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <p class="text-h5 text--primary">Телефон тех. поддержки - 8 800 700-09-54</p>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-card v-if="step_number == 3">
            <appeals-connect @connected="onConnected"></appeals-connect>
          </v-card>
          <v-card v-if="step_number == 4">
            <v-card class="pa-6">
              <v-card-title><p class="text-h5 text--primary">Ожидание подключения</p></v-card-title>
            </v-card>
          </v-card>
          <v-card v-if="step_number == 5">
            <v-card-title><p class="text-h5 text--primary">Успешно подключено</p></v-card-title>
          </v-card>
        </v-stepper-content>

        <!-- <v-stepper-content step="4">
          <v-card class="pa-6">
            <p class="text-h5 text--primary">Ожидание подключения</p>
            <v-btn
                v-if="operationDetailsLink"
                :href="operationDetailsLink"
                target="_blank"
                color="primary"
            >
                Детали запроса
            </v-btn>
          </v-card>
        </v-stepper-content> -->

        <!-- <v-stepper-content step="5">
          <v-card class="pa-6">
            <p class="text-h5 text--primary">Подключение установлено</p>
          </v-card>
        </v-stepper-content> -->
      </v-stepper-items>
    </v-stepper>
    <v-skeleton-loader
      v-if="ORGANIZATION_IS_FETCHING"
      class="mx-auto"
      type="card"
    ></v-skeleton-loader>
    <v-row justify="center">
      <v-dialog
        v-model="dialogConfirmPhone"
        max-width="600"
      >
        <v-card>
          <v-card-title class="text-h5">
            Проверьте, правильно ли введен Ваш номер? <br/> {{ new_contact_mobile }}
          </v-card-title>
          <v-card-text>Если есть ошибка, то исправьте, иначе не сможем вам позвонить и настроить подключение appeals.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="dialogConfirmPhone = false"
            >
              Исправить
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              @click="onNextStep"
            >
              Продолжить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import OrgnizationForm from '../../../components/Organization/OrgnizationForm.vue';
import AppealsConnect from '../../components/appeals/AppealsConnect.vue';

export default {
  name: 'AppealsConnectPage',
  components: {
    OrgnizationForm,
    AppealsConnect
  },
  data: () => ({
    new_contact_mobile: '',
    isFetchingMobile: false,
    confirmPhone: false,
    validformPhone: true,
    dialogConfirmPhone: false,
  }),
  mounted() {
    if (this.CONTACT_PHONES.length > 0) {
      this.new_contact_mobile = this.CONTACT_PHONES[0];
    }
  },
  watch: {
    step_number: {
      handler(newVal) {
        if (newVal === 4) {
          setTimeout(() => {
            this.$router.push({ name: 'appeals.connect.pending'});
          }, 2000);
        }
        if (newVal === 5) {
          setTimeout(() => {
            this.$router.push({ name: 'appeals.list'});
          }, 2000);
        }
      },
      immediate: true,
      flush: 'post'
    }
  },
  methods: {
    ...mapActions('user', ['ADD_CONTACT_PHONE']),
    ...mapActions('notifications', ['SHOW_ERROR']),
    ...mapActions('organization', ['setAppealsServiceConnectionStatusConnection']),
    ...mapActions('workspace', ['RELOAD_ORGANIZATION']),
    onOpenConfirmDialog() {
      if (!this.$refs.formPhone.validate()) {
        this.SHOW_ERROR('Не указан номер телефона');
        return false;
      }
      this.dialogConfirmPhone = true;
    },
    async onNextStep() {
      if (!this.$refs.formPhone.validate()) {
        this.SHOW_ERROR('Не указан номер телефона');
        return false;
      }
      if (!this.HAS_CONTACT_PHONE_NUMBER(this.new_contact_mobile)) {
        try {
          await this.onSaveNewContact();
        } catch (e) {
          this.dialogConfirmPhone = false;
          throw e;
        }
      }
      this.dialogConfirmPhone = false;
      this.confirmPhone = true;
    },
    async onSaveNewContact() {
      if (!this.$refs.formPhone.validate()) {
        this.SHOW_ERROR('Не указан номер телефона');
        return false;
      }
      this.isFetchingMobile = true;
      try {
        await this.ADD_CONTACT_PHONE(this.new_contact_mobile);
      } finally {
        this.isFetchingMobile = false;
      }
    },
    onConnected() {
      this.setAppealsServiceConnectionStatusConnection();
      this.RELOAD_ORGANIZATION();
    }
  },
  computed: {
    ...mapGetters('user', ['HAS_CONTACT_PHONE', 'CONTACT_PHONES', 'HAS_CONTACT_PHONE_NUMBER']),
    ...mapGetters('workspace', ['COUNT_ORGANIZATIONS', 'ORGANIZATION_IS_FETCHING']),
    ...mapGetters('organization', ['appealsServiceConnection']),
    stepper_step(){
        return this.step_number > 3 ? 3 : this.step_number
    },
    step_number() {
        if (this.appealsServiceConnection && this.appealsServiceConnection.status === 'CONNECTED') {
            return 5;
        }
        if (this.appealsServiceConnection && this.appealsServiceConnection.status === 'CONNECTION') {
            return 4;
        }
        if (this.COUNT_ORGANIZATIONS === 0) {
            return 1;
        }
        if (!this.HAS_CONTACT_PHONE || !this.confirmPhone) {
            return 2;
        }
        return 3;
    },
    title_text() {
      if (this.step_number === 1) {
        return 'Начнем подключение сервиса';
      }
      if (this.step_number === 2) {
        return 'Почти завершили! Осталось еще чуть-чуть';
      }
      if (this.step_number === 4) {
        return 'Ожидание подключения';
      }
      if (this.step_number === 5) {
        return 'Подключение установлено';
      }
      return '';
    },
    operationDetailsLink(){
        if (this.appealsServiceConnection?.extra?.connection?.gisRequest?.externalOperationId) {
            return `https://coreui.ais24.ru/operations/${this.appealsServiceConnection.extra.connection.gisRequest.externalOperationId}`;
        }
        return null;
    }
  },
}
</script>

<style scoped>

</style>
